import type { Cart } from './cart';
import { data, find, findAll } from './dom';

// Količina i „Stavi u korpu“ na stranici proizvoda, u okviru ispod cene i u traci na dnu ekrana telefona i tableta (CSS
// prikazuje jedno od njih). Oba dela dele istu količinu, pa ona ostaje i kad se ekran okrene ili suzi. Proizvod ide u
// porudžbinu sa bojom izabranom u galeriji i njenom sličicom (bez pločica boja sa velikom slikom). Bez skripte porudžbina ne
// radi, pa oba dela ostaju skrivena.
export function enhanceProductOrder(cart: Cart): void {
  const parts = findAll(document, 'product-order', HTMLElement).map(order => ({
    order,
    quantity: find(order, 'order-quantity', HTMLInputElement),
  }));
  const [first] = parts;
  if (first === undefined) return;

  const minimum = Number(first.quantity.min);
  const maximum = Number(first.quantity.max);

  // Granice i ceo broj važe kad kupac završi upis (change), posle − i + i pre dodavanja u korpu; dok kuca, broj se samo
  // prepisuje u drugo polje (ne i u polje u kome kuca, da kursor ostane gde jeste).
  const setQuantity = (value: number): void => {
    const count = Number.isFinite(value) ? Math.round(value) : minimum;
    const text = String(Math.max(minimum, Math.min(maximum, count)));
    parts.forEach(({ quantity }) => {
      quantity.value = text;
    });
  };

  const copy = (source: HTMLInputElement): void =>
    parts.forEach(({ quantity }) => {
      if (quantity !== source) quantity.value = source.value;
    });

  const add = (order: HTMLElement, quantity: number): void => {
    const color = document.querySelector('[data-js="gallery-color"][aria-current="true"]');
    const thumb = (color ?? document.querySelector('[data-js="gallery"]'))?.querySelector('img');
    cart.add({
      product: data(order, 'product'),
      name: data(order, 'name'),
      color: color instanceof HTMLElement ? data(color, 'color') : null,
      image: thumb?.getAttribute('src') ?? null,
      quantity,
    });
  };

  parts.forEach(({ order, quantity }) => {
    findAll(order, 'order-step', HTMLButtonElement).forEach(button =>
      $(button).on('click', () => setQuantity(quantity.valueAsNumber + Number(data(button, 'step'))))
    );
    $(quantity).on('input', () => copy(quantity));
    $(quantity).on('change', () => setQuantity(quantity.valueAsNumber));
    $(find(order, 'order-add', HTMLButtonElement)).on('click', () => {
      setQuantity(quantity.valueAsNumber);
      add(order, quantity.valueAsNumber);
    });
    order.hidden = false;
  });
}
